import { render, staticRenderFns } from "./UserInput.vue?vue&type=template&id=8c7132ec&scoped=true"
import script from "./UserInput.vue?vue&type=script&lang=js"
export * from "./UserInput.vue?vue&type=script&lang=js"
import style0 from "./UserInput.vue?vue&type=style&index=0&id=8c7132ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7132ec",
  null
  
)

export default component.exports